import { Box, HStack, Text, VStack, useTheme } from 'native-base'
import { useMemo } from 'react'
import { isMobile } from 'react-device-detect'

import CheckCircleIcon from '../../assets/CheckCircle.svg'
import WarningIcon from '../../assets/Warning.svg'
import { useScreenSize } from '../../utils/displayUtils'
import { colors } from '../../utils/theme/configureTheme'
import { HeaderType, SubmissionHeaderProps } from './types'

/** Header of the issue submission confirmation screen with title and body text. */
export default function SubmissionHeader({ headerType, headerText, headerBodyText }: SubmissionHeaderProps) {
  const screenSize = useScreenSize()
  const isMobileScreen = isMobile || screenSize.width < 800
  const theme = useTheme()
  const backgroundColor = useMemo(() => {
    switch (headerType) {
      case HeaderType.SUCCESS:
        return theme.colors.success[100]
      case HeaderType.WARNING:
        return colors.brand.marigold
      case HeaderType.INFO:
      default:
        return colors.brand.lightBlue
    }
  }, [headerType, theme.colors.success])
  const borderColor = useMemo(() => {
    switch (headerType) {
      case HeaderType.SUCCESS:
        return colors.brand.successDarkGreen
      case HeaderType.WARNING:
        return colors.brand.darkMarigold
      case HeaderType.INFO:
      default:
        return colors.brand.selectedDarkBlue
    }
  }, [headerType])
  const getIcon = () => {
    switch (headerType) {
      case HeaderType.SUCCESS:
        return CheckCircleIcon
      case HeaderType.WARNING:
        return WarningIcon
      case HeaderType.INFO:
      default:
        return null
    }
  }
  const icon = getIcon()
  const borderRadius = useMemo(() => {
    return isMobileScreen ? 0 : 8
  }, [isMobileScreen])

  return (
    <Box
      width="100%"
      backgroundColor={backgroundColor}
      px={4}
      py={3}
      borderRadius={borderRadius}
      mb={2}
      borderColor={borderColor}
      borderWidth={1}
    >
      <VStack space={2} alignItems="flex-start">
        <HStack space={2} alignItems="center">
          {icon && (
            <Box mt={1}>
              <img src={icon} alt={headerType} style={{ width: '24px', height: '24px' }} />
            </Box>
          )}
          <Text
            fontSize={'20px'}
            fontWeight={700}
            color={colors.brand.softBlack}
            lineHeight="125%"
            letterSpacing={'-0.2%'}
            fontFamily="Matter Bold"
          >
            {headerText}
          </Text>
        </HStack>
        <VStack flex={1} space={1}>
          <Text
            fontSize={'14px'}
            fontWeight={500}
            color={colors.brand.softBlack}
            lineHeight="125%"
            letterSpacing={'-0.1%'}
            fontFamily="Matter Regular"
          >
            {headerBodyText}
          </Text>
        </VStack>
      </VStack>
    </Box>
  )
}
